import { DatePipe } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  input,
  numberAttribute,
  untracked,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { agentCounts } from '../../domain/agent-counts';
import { agentName, twoDigits } from '../../domain/format';
import { apiErrorMessage } from '../../services/api-error';
import { MissionService } from '../../services/mission.service';
import { PlayerSessionService } from '../../services/player-session.service';
import { reloadEvery } from '../../services/polling';
import { PublicOperationService } from '../../services/public-operation.service';
import { Dossier } from '../../shared/dossier/dossier';
import { GameStatus } from '../../shared/game-status/game-status';
import { PageTitle } from '../../shared/page-title/page-title';
import { Roster } from '../../shared/roster/roster';
import { StatePanel } from '../../shared/state-panel/state-panel';
import { TargetCard } from '../../shared/target-card/target-card';

// Salle de debriefing d'un agent sorti du jeu, elimine ou ayant abandonne (TD-021).
// Il n'est plus en jeu : la fiche d'effectif peut lui etre montree.
@Component({
  selector: 'app-debrief-page',
  imports: [DatePipe, Dossier, GameStatus, PageTitle, Roster, RouterLink, StatePanel, TargetCard],
  templateUrl: './debrief-page.html',
})
export class DebriefPage {
  readonly missionId = input.required({ transform: numberAttribute });

  private readonly session = inject(PlayerSessionService);
  private readonly missions = inject(MissionService);

  protected readonly mission = this.missions.mission(() => this.missionId());
  protected readonly debrief = this.missions.debrief(() => this.missionId());
  protected readonly operation = inject(PublicOperationService).operation(
    () => this.mission.value()?.operationPublicId,
  );

  protected readonly agentName = agentName;
  protected readonly counts = computed(() => agentCounts(this.operation.value()?.ranking ?? []));
  protected readonly complete = computed(() => this.operation.value()?.statusCode === 'COMPLETE');
  protected readonly score = computed(() => twoDigits(this.debrief.value()?.score ?? 0));
  protected readonly loadError = computed(() => {
    const error = this.mission.error() ?? this.debrief.error();
    return error ? apiErrorMessage(error) : null;
  });

  constructor() {
    reloadEvery(this.operation, 15_000);

    // Apres une regeneration d'acces, le front ne connait le nom de code qu'ici.
    effect(() => {
      const codeName = this.debrief.value()?.codeName;
      if (codeName) {
        untracked(() => this.session.rememberCodeName(this.missionId(), codeName));
      }
    });
  }
}
